import { render, staticRenderFns } from "./homeWindowPromotion.vue?vue&type=template&id=61d386f6&scoped=true&"
import script from "./homeWindowPromotion.vue?vue&type=script&lang=js&"
export * from "./homeWindowPromotion.vue?vue&type=script&lang=js&"
import style0 from "./homeWindowPromotion.vue?vue&type=style&index=0&id=61d386f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d386f6",
  null
  
)

component.options.__file = "homeWindowPromotion.vue"
export default component.exports